<script lang="ts" context="module">
  import { supabase } from "$lib/data/supabase";

  import type { definitions } from "$lib/types/supabase";

  import type { Load } from "@sveltejs/kit";

  export const load: Load = async function () {
    const { data, error } = await supabase
      .from<definitions["algo_uses"]>("algo_uses")
      .select("slug, title, description");

    if (data) {
      return {
        props: { algo_uses: data },
      };
    } else {
      return {};
    }
  };
</script>

<script lang="ts">
  import AlgoUseCard from "$lib/components/Content/Configuration/AlgoUseCard.svelte";
  import Faq from "$lib/components/Docs/Faq.svelte";

  export let algo_uses: definitions["algo_uses"][];
</script>

<svelte:head>
  <title>Docs for Locational Algorithms</title>
</svelte:head>

<div class="is-size-3 block">Algorithm documentation</div>
{#if algo_uses.length}
  {#each algo_uses as algo_use}
    <AlgoUseCard {algo_use} size_px={52} />
  {/each}
{:else}
  <p>No algorithms found</p>
{/if}

<Faq />
